var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgComplete = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.907 16.733l-5.594-4.769 1.524-1.635 3.747 3.194 6.36-7.993 1.824 1.326-7.86 9.877z"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjExIiAvPgogICAgPHBhdGggZD0iTTkuOTA3NDIgMTYuNzMyOUw0LjMxMjg3IDExLjk2NDVMNS44MzcxMiAxMC4zMjlMOS41ODM2OCAxMy41MjI1TDE1Ljk0MzcgNS41MzAyN0wxNy43NjgxIDYuODU1NTdMOS45MDc0MiAxNi43MzI5WiIgLz4KPC9zdmc+";
export { SvgComplete as ReactComponent };